export default "__VITE_ASSET__96wrdRrv__"